import { FeedPreferenceGameLocations } from './settings';

export const DefaultFeedLocation = {
    location: 'Palo Alto, CA, USA',
    lat: '37.4418834',
    lng: '-122.1430195',
};

const fromGeocoded = (geocoded) => {
    if (geocoded?.lat == null || geocoded?.lng == null) {
        return null;
    }
    return { location: geocoded.location, lat: geocoded.lat, lng: geocoded.lng };
};

const fromProfile = (userLocation) => {
    if (userLocation?.latLng?.[0] == null || userLocation?.latLng?.[1] == null) {
        return null;
    }
    return { location: userLocation.display, lat: userLocation.latLng[0], lng: userLocation.latLng[1] };
};

export const resolveFeedLocation = (gameLocation, geocoded, userLocation) => {
    const geocodedLocation = fromGeocoded(geocoded);
    const profileLocation = fromProfile(userLocation);

    if (gameLocation === FeedPreferenceGameLocations.PROFILE) {
        return profileLocation || geocodedLocation || DefaultFeedLocation;
    }
    return geocodedLocation || profileLocation || DefaultFeedLocation;
};
